<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Name Input -->
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model.trim="filterOptions.name"
              />
              <!-- End:: Name Input -->

              <!-- Start:: Phone Input -->
              <base-input
                col="3"
                type="tel"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="filterOptions.email"
              />
              <!-- End:: Phone Input -->
              <!-- Start:: Phone Input -->
              <base-input
                col="3"
                type="tel"
                :placeholder="$t('PLACEHOLDERS.phone')"
                v-model.trim="filterOptions.phone"
              />

              <!-- End:: Phone Input -->

              <!-- Start:: Status Input -->
              <base-select-input
                col="3"
                :optionsList="activeStatuses"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="filterOptions.isActive"
              />
              <!-- End:: Status Input -->
            </div>

            <div class="btns_wrapper">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.search") }}</span>
                </template>
                <span
                  class="submit_btn"
                  @click="submitFilterForm"
                  :disabled="isWaitingRequest"
                >
                  <i class="fal fa-search"></i>
                </span>
              </a-tooltip>

              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.rseet_search") }}</span>
                </template>
                <span
                  class="reset_btn"
                  :disabled="isWaitingRequest"
                  @click="resetFilter"
                >
                  <i class="fal fa-redo"></i>
                </span>
              </a-tooltip>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.manage_all_users") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
        <div class="title_route_wrapper" v-if="$can('users create', 'users')">
          <router-link to="/clients/create">
            {{ $t("PLACEHOLDERS.add_client") }}
          </router-link>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->
      <div class="d-flex justify-content-between">
        <v-col
          cols="auto"
          md="auto"
          sm="auto"
          class="d-flex justify-center my-4 gap-2"
        >
          <v-btn
            v-if="selected.length"
            @click="openDeleteDialogForSelected"
            size="x-large"
            color="error"
          >
            {{ $t("PLACEHOLDERS.delete_selected") }}
          </v-btn>
        </v-col>
        <base-input
          :label="$t('TITLES.item_per_page')"
          :placeholder="$t('TITLES.item_per_page')"
          col="5"
          type="number"
          class="my-0 base-input py-0"
          v-model="paginations.items_per_page"
        />
      </div>

      <!--  =========== Start:: Data Table =========== -->

      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        v-model="selected"
        show-select
        item-class="ltr"
        :items-per-page="
          paginations.items_per_page === ''
            ? 10
            : Number(paginations.items_per_page)
        "
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:header.data-table-select>
          <v-checkbox
            :disabled="tableRows.every((row) => row.can_remove === false)"
            v-model="myHeaderCheck"
            @click.stop="handleHeaderClick"
          />
        </template>

        <template v-slot:item.data-table-select="{ isSelected, select, item }">
          <v-checkbox
            :input-value="isSelected"
            @change="select($event)"
            color="primary"
            hide-details
            :disabled="!item.can_remove"
            dense
          />
        </template>

        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item?.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>

        <!-- Start:: Name -->
        <template v-slot:[`item.name`]="{ item }">
          <h6 class="text-danger" v-if="!item.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.name }}</h6>
        </template>
        <!-- End:: Name -->

        <!-- Start:: Activation -->
        <template v-slot:[`item.is_active`]="{ item }">
          <template>
            <span class="text-success text-h5" v-if="item.is_active">
              <i class="far fa-check"></i>
            </span>
            <span class="text-danger text-h5" v-else>
              <i class="far fa-times"></i>
            </span>
          </template>
        </template>
        <!-- End:: Activation -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip
              placement="bottom"
              v-if="$can('users edit', 'users') && item?.id !== 1"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>
              <button class="btn_edit" @click="editItem(item)">
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip>

            <template>
              <a-tooltip
                placement="bottom"
                v-if="$can('users delete', 'users')"
              >
                <template slot="title">
                  <span>{{ $t("BUTTONS.delete") }}</span>
                </template>
                <button class="btn_delete" @click="selectDeleteItem(item)">
                  <i class="fal fa-trash-alt"></i>
                </button>
              </a-tooltip>

              <a-tooltip placement="bottom" v-if="$can('users show', 'users')">
                <template slot="title">
                  <span>{{ $t("BUTTONS.show") }}</span>
                </template>
                <button class="btn_show" @click="showItem(item)">
                  <i class="fal fa-eye"></i>
                </button>
              </a-tooltip>

              <a-tooltip
                :disabled="!item.has_active_subscription"
                placement="bottom"
                v-if="$can('users show', 'users')"
              >
                <template slot="title">
                  <span>{{ $t("BUTTONS.show") }}</span>
                </template>
                <span>
                  <button
                    class="btn_show"
                    @click="selectChangeRemainingAdsItem(item)"
                    :disabled="!item.has_active_subscription"
                  >
                    <i class="fas fa-battery-half"></i>
                  </button>
                </span>
              </a-tooltip>
              <a-tooltip placement="bottom" v-if="!item.is_active">
                <template slot="title">
                  <span>{{ $t("BUTTONS.activate") }}</span>
                </template>
                <button
                  class="btn_activate"
                  @click="HandlingItemActivationStatus(item)"
                >
                  <i class="fad fa-check-circle"></i>
                </button>
              </a-tooltip>
              <a-tooltip placement="bottom" v-if="item.is_active">
                <template slot="title">
                  <span>{{ $t("BUTTONS.deactivate") }}</span>
                </template>
                <button
                  class="btn_deactivate"
                  @click="selectDeactivateItem(item)"
                >
                  <i class="fad fa-times-circle"></i>
                </button>
              </a-tooltip>
            </template>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Deactivate Modal -->
          <v-dialog v-model="dialogDeactivate">
            <v-card>
              <v-card-title
                class="text-h5 justify-center"
                v-if="itemToChangeActivationStatus"
              >
                {{
                  $t("TITLES.DeactivateConfirmingMessage", {
                    name: itemToChangeActivationStatus.name,
                  })
                }}
              </v-card-title>

              <form class="w-100">
                <base-input
                  col="12"
                  rows="3"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.deactivateReason')"
                  v-model.trim="deactivateReason"
                  required
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="HandlingItemActivationStatus"
                  :disabled="
                    !!!deactivateReason || deactivateReason?.length < 3
                  "
                >
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn
                  class="modal_cancel_btn"
                  @click="dialogDeactivate = false"
                  >{{ $t("BUTTONS.cancel") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>
              <v-card-title v-if="!itemToDelete" class="text-h5 justify-center">
                {{ $t("TITLES.delete_selected") }}
              </v-card-title>
              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="
                    !itemToDelete
                      ? confirmDeleteSelected()
                      : confirmDeleteItem()
                  "
                  >{{ $t("BUTTONS.ok") }}</v-btn
                >

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogWallet">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{
                  $t("PLACEHOLDERS.walletAmount") + " " + updateRemaining || 0
                }}
              </v-card-title>

              <!-- <h2>{{ walletBalance }}</h2> -->
              <form class="w-100" @submit.prevent="EditWalletBalance">
                <base-input
                  col="12"
                  type="number"
                  :placeholder="$t('PLACEHOLDERS.amount')"
                  v-model.trim="updateRemaining"
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="EditWalletBalance"
                  :loading="isWaitingRequest"
                  :disabled="
                    updateRemaining == itemToChangeRemainAds?.remaining_ads ||
                    isWaitingRequest
                  "
                >
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogWallet = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Deactivate Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "Allusers",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      myHeaderCheck: false,
      selected: [],
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        phone: null,
        email: null,
        isActive: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Clients.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Clients.name"),
          value: "name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Clients.phone"),
          value: "mobile",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.email"),
          value: "email",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.sub_at"),
          value: "created_at",
          align: "center",
          sortable: false,
        },
        // {
        //   text: this.$t("PLACEHOLDERS.registration_otp_status"),
        //   value: "is_verified",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: this.$t("TABLES.Clients.active"),
          value: "is_active",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Clients.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data

      dialogDelete: false,
      itemToDelete: null,

      dialogDeactivate: false,
      itemToChangeActivationStatus: null,
      deactivateReason: null,

      dialogBalance: false,
      itemToChangeRemainAds: null,
      excel_link: null,

      dialogWallet: false,
      updateRemaining: 0,
      newWalletBalance: null,
      itemToChargeWallet: null,
      reason: null,
      newWalletBalance: null,
      itemToChargeWallet: null,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.myHeaderCheck = false;
      this.selected = [];
      this.myHeaderCheck = false;
      this.setTableRows();
    },
    "paginations.items_per_page"(newVal, oldVal) {
      this.paginations.current_page = 1;
      this.debouncedFetch();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
    selected(data) {
      if (data.length == 0) {
        this.myHeaderCheck = false;
      } else {
        this.myHeaderCheck = true;
      }
    },
  },

  methods: {
    async confirmDeleteSelected() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "DELETE");
      this.selected.map((item, index) => {
        REQUEST_DATA.append(`ids[${index}]`, `${item.id}`);
      });
      try {
        await this.$axios({
          method: "POST",
          url: `users/remove-many`,
          data: REQUEST_DATA,
        });
        this.dialogDelete = false;

        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.delete_selected_successfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },

    handleHeaderClick() {
      if (this.myHeaderCheck) {
        this.selected = this.tableRows.filter((item) => item.can_remove);
      } else {
        this.selected = [];
      }
    },
    debouncedFetch: debounce(function () {
      this.setTableRows();
    }, 500),
    openDeleteDialogForSelected() {
      this.itemToDelete = null;
      this.dialogDelete = true;
    },
    async downloadPdf() {
      window.location.href = this.excel_link;
    },
    async EditWalletBalance() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.updateRemaining) {
        REQUEST_DATA.append("remaining_ads", this.updateRemaining);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `users/change-remaining-ads/${this.itemToChangeRemainAds?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.dialogWallet = false;
        this.$message.success(this.$t("PLACEHOLDERS.remainingAdsUpdated"));
        this.setTableRows();
        this.itemToChangeRemainAds = null;
        this.updateRemaining = null;
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    selectChangeRemainingAdsItem(item) {
      this.dialogWallet = true;
      this.updateRemaining = item.remaining_ads;
      this.itemToChangeRemainAds = item;
    },
    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `users/${this.itemToDelete?.id}`,
        });
        this.dialogDelete = false;

        this.tableRows = this.tableRows.filter((item) => {
          return item.id != this.itemToDelete?.id;
        });

        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/clients/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.name = null;
      this.filterOptions.phone = null;
      this.filterOptions.email = null;
      this.filterOptions.isActive = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/clients/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "users",
          params: {
            page: this.paginations.current_page,
            type: "client",
            name: this.filterOptions.name,
            email: this.filterOptions.email,
            mobile: this.filterOptions.phone,
            status: this.filterOptions.isActive?.value,
            limit:
              this.paginations.items_per_page === ""
                ? 10
                : Number(this.paginations.items_per_page),
          },
        });
        this.loading = false;
        this.tableRows = res.data.data;
        this.selected = [];
        this.myHeaderCheck = false;
        this.paginations.last_page = res.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },
    // Start:: Change Activation Status
    async toggleStatus(item) {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("id", item?.id);
      try {
        await this.$axios({
          method: "POST",
          url: `users/toggle-status`,
          data: REQUEST_DATA,
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.changeActivation"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Change Activation Status

    // ==================== Start:: Crud ====================
    editItem(item) {
      this.$router.push({ path: `/clients/edit/${item.id}` });
    },
    // ===== Start:: Show
    showItem(item) {
      this.$router.push({ path: `/clients/show/${item?.id}` });
    },
    // ===== End:: Show

    // ===== Start:: Handling Activation & Deactivation
    selectDeactivateItem(item) {
      this.dialogDeactivate = true;
      this.itemToChangeActivationStatus = item;
    },
    async HandlingItemActivationStatus(selectedItem) {
      this.dialogDeactivate = false;
      let targetItem = this.itemToChangeActivationStatus
        ? this.itemToChangeActivationStatus
        : selectedItem;
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.deactivateReason) {
        REQUEST_DATA.append("reason", this.deactivateReason);
        REQUEST_DATA.append("is_active", 0);
      } else {
        REQUEST_DATA.append("is_active", 1);
      }
      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `users/activate/${targetItem?.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
        this.setTableRows();
        this.itemToChangeActivationStatus = null;
        this.deactivateReason = null;
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // ===== End:: Handling Activation & Deactivation

    async confirmAcceptItem(item) {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("balance", this.balance_package);
      // REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `change-client-balance/${this.itemToChangeRemainAds?.id}`,
          data: REQUEST_DATA,
        });
        this.dialogBalance = false;
        (this.balance_package = null), this.setTableRows();
        this.$message.success(this.$t("MESSAGES.verifiedSuccessfully"));
      } catch (error) {
        this.dialogBalance = false;
        this.$message.error(error.response.data.message);
      }
    },
    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>
<style>
span.submit_btn {
  width: 45px;
  height: 45px;
  font-size: 16px;
  border-radius: 10px;
  color: var(--white_clr);
  transition: all 0.3s linear;
  background-color: #f6a513;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
